import env from '../env.json'

export default {
  sistema: {
    nome: 'Dados Abertos',
    sigla: 'dadosabertos',
    descricao: 'Sistema para exibição de dados abertos'
  },
  apiUrl: env.apiUrl,
  imgUrl: env.imgUrl
}



// WEBPACK FOOTER //
// ./src/config.js